GP.models.Comment = Backbone.Model.extend({
    idAttribute:'id',
    defaults:{
        comment_id: null,
        content_id: null,
        comment_duid: null,
        url: null,
        username: null,
        body: null,
        gender: null,
        timeago: null,
        ctime: null,
        online_status: null,
        my_profile: null,
        tag: null,
        account_status: null,
        reply_count : null,
        parent_comment_id: null,
        replies : []
    },
    initialize: function(data) {
        this.set('replies', new GP.collections.Comments(data.replies));
    }
});